
export const auth0Config = {
  base_url: process.env.REACT_APP_AUTH0_BASE_URL,
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  issuer_base_url: process.env.REACT_APP_AUTH0_ISSUER_BASE_URL,
};
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "auth.b2brocket.ai",
  projectId: "leadingly-application",
  storageBucket: "leadingly-application.appspot.com",
  messagingSenderId: "210905395537",
  appId: "1:210905395537:web:b3519715bb52ce0614a370",
  measurementId: "G-PP2R56FRJ9",
};
export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID,
};
export const mapboxConfig = {
  apiKey: process.env.REACT_APP_MAPBOX_API_KEY,
};
export const MIN_LEADS = 20000;
export const MAILBOXES_PER_CAMPAIGN = 0; // remember to change this to 10
export const LEADS_PER_PAGE = 50;
export const LEADS_SIGNAL_PER_PAGE = 10;
export const UPDATE_CHARTS_EVERY_X_SECS = 10;
export const DEFAULT_DAYS_ON_CHART = 7; // @ browse campaign page
export const CAMPAIGN_PER_PAGE = 10;
// ---------------------------Switch PRODUCTION / LOCAL------------------------------------------------
// Domains where local token (b2b_at_local) auth is used and API is routed to partners.b2brocket.ai
export const LOCAL_ENV_DOMAINS = ['localhost', 'azurestaticapps.net'];

export const isLocalOrStagingEnv = () => {
  const hostname = window.location.hostname;
  return LOCAL_ENV_DOMAINS.some(domain =>
    hostname === domain || hostname.endsWith(`.${domain}`)
  );
};

// Local
let pvtIP;
export const SERVER_DOMAIN = isLocalOrStagingEnv()
  ? 'https://app.b2brocket.ai/api'
  : `${window.location.origin}/api`;
// export const SERVER_DOMAIN = `gateway.b2brocket.ai`;
export const BASE_URL = SERVER_DOMAIN;
// export const BASE_URL = `https://${SERVER_DOMAIN}`;

// pvtIP = "192.168.29.26";
export const HELP_URL = "https://help.b2brocket.ai/en/articles";
// export const agentUrl = "https://b2brocket-agent-tp3r.onrender.com";
export const agentUrl = `${BASE_URL}/b2bagent`;
// export const agentUrl = "http://localhost:8081";
//export const agentUrl = "https://gateways.b2brocket.ai/agentstaging";
// export const API_SERVICE_AUTOMATION_BACKEND  = `${BASE_URL}/agentstaging`;
// export const agentUrl = "https://api.b2brocket.ai";
export const DEFAULT_BDR_AGENT_ID = process.env.REACT_APP_DEFAULT_BDR_AGENT_ID; // default bdr agent id for lead finder
export const DEFAULT_STRATEGIST_AGENT_ID = process.env.REACT_APP_DEFAULT_STRATEGIST_AGENT_ID; // not in use right now ( for use this we need copywriter agent)
export const API_SERVICE_EMAIL_SLAVE_URL = `${BASE_URL}/eslave/api/v1/main`;
export const API_SERVICE_BACKEND_GENERATE_TEMPLATES =
  `${BASE_URL}/eslave/api/v1/main/generate-templates`;
// export const selfURL = `http://${domain}:3000`;
// export const COMMUNICATION_SERVER = `http://${domain}:8090`;
// export const EMAIL_SERVER = `http://${domain}:8085`;
// export const SOCKET_URL = `http://${domain}:8080`;
// export const API_SERVICE_CREDITS = `http://localhost:8090/api/v1/main`; // credits tracker
// export const API_SERVICE_BACKEND = `${BASE_URL}/clientbackend/api/v1/main`; // leadingly_testapp_backend
// export const API_EMAIL_REPLIES_PUBSUB = `http://${domain}:5050/api/v1/main`; // email replies pubsub
// export const API_SERVICE_BACKEND_V2 = `${BASE_URL}/clientbackend/api/v2/main`; // leadingly_testapp_backend v2
// export const API_SERVICE_BACKEND_2 = `http://${domain}:8090/api/v1/main`; // leadingly_backend
// export const API_SERVICE_BACKEND_3 = `http://${domain}:8081/api/v1/main`; // meetings_b2brocket_server
// // export const API_SERVICE_BACKEND_CRONOFY = `${API_SERVICE_BACKEND_3}`;
// export const ADMIN_SERVER = API_SERVICE_BACKEND_2;
// export const EMAIL_SERVICE_AZURE = "http://localhost:8282/api/v1/main";  
// export const EMAIL_SERVICE_AZURE_SOCKET = "http://localhost:8282";
// export const EMAIL_SAMPLE_TEST_AZURE = "http://localhost:3003";
// export const EMAIL_SERVER_SLAVE = "https://da88-2401-4900-1f3f-83f6-40cf-4455-c98-4d95.ngrok-free.app";

// STAGING
// export const selfURL = `https://icy-ground-0e127080f-jboutboundcall.eastus2.6.azurestaticapps.net`;
// export const API_SERVICE_BACKEND = "https://leadingly-testapp-backend.onrender.com/api/v1/main"; // leadingly_testapp_backend
// export const API_SERVICE_BACKEND_V2 = "https://leadingly-testapp-backend.onrender.com/api/v2/main"; // leadingly_testapp_backend v2
// export const EMAIL_SERVER_SLAVE = "https://jb-email-service-slave.onrender.com";


// Production
export const PROD_DOMAIN = "app.b2brocket.ai";
export const selfURL = "https://app.b2brocket.ai";
export const COMMUNICATION_SERVER =
  "https://campaign-incoming-mail-service-azure-devops.azurewebsites.net";
export const EMAIL_SERVER =
  "https://campaign-email-service-azure-devops.azurewebsites.net";
export const EMAIL_SERVER_SLAVE = `${BASE_URL}/eslave`;
// export const EMAIL_SERVER_SLAVE = "https://b2b-multichannel.azurewebsites.net";
export const SOCKET_URL = `${BASE_URL}/clientbackend/`;
export const API_AUTH_SERVICE_BACKEND = `${BASE_URL}/auth/auth/api/v1`;
// export const API_AUTH_SERVICE_BACKEND = "http://localhost:8080/auth/auth/api/v1"; // local
export const API_SERVICE_CREDITS = `${BASE_URL}/credits/api/v1/main`; // credits tracker
export const API_SERVICE_BACKEND = `${BASE_URL}/clientbackend/api/v1/main`; // leadingly_testapp_backend
export const API_SERVICE_BACKEND_V2 = `${BASE_URL}/clientbackend/api/v2/main`; // leadingly_testapp_backend v2
export const API_SERVICE_BACKEND_2 = `${BASE_URL}/adminbe/api/v1/main`; // leadingly_backend
export const API_SERVICE_BACKEND_3 = `${BASE_URL}/meeting/api/v1/main`; // meetings_b2brocket_server
export const API_EMAIL_REPLIES_PUBSUB =
  "https://replies-pubsub.b2brocket.ai/api/v1/main"; // email replies pubsub
export const API_SERVICE_AUTOMATION_BACKEND  = `${BASE_URL}/agentstaging`;
// export const API_ADMIN_SERVICE_BACKEND = `${BASE_URL}/apiadmin/api/v1/main`; // apiadmin_backend_deprecated
// export const API_SERVICE_BACKEND_2 = "http://localhost:8090/api/v1/main";
export const API_SERVICE_BACKEND_CRONOFY = `${API_SERVICE_BACKEND_3}`;
export const ADMIN_SERVER = API_SERVICE_BACKEND_2;
export const EMAIL_SERVICE_AZURE =
  "https://leadingly-azure-generate-sample-emails.azurewebsites.net/api/v1/main";
export const EMAIL_SERVICE_AZURE_SOCKET =
  "https://leadingly-azure-generate-sample-emails.azurewebsites.net";
export const EMAIL_SAMPLE_TEST_AZURE =
  "https://b2b-email-sample-response.azurewebsites.net";
// export const API_SERVICE_BACKEND_LEADS_GENERATION =
//   "https://b2-leads-gen-apollo-2f3af681d731.herokuapp.com/api/v1/main"; // b2b_leads_generation
export const API_SERVICE_BACKEND_LEADS_GENERATION = `${BASE_URL}/leadgenapi/api/v1/main`; // b2b_leads_generation
export const API_SERVICE_BACKEND_ANALYTICS_DATA = `${BASE_URL}/pixeltracking`; // analyticsAPI
export const OUTBOUND_CALL_SLAVE = `${BASE_URL}/eslave`;
// export const OUTBOUND_CALL_SLAVE =
//   `${BASE_URL}/eslave`;
// export const SALES_CHAT = "https://react-sales-agent.vercel.app/chat";
// export const SALES_CHAT = "http://www.brandheroes.io/chat";
// export const COMMUNICATION_SERVER =
//   "https://email-receive-service-54411742d1b6.herokuapp.com";
// export const EMAIL_SERVER =
//   "https://campaign-email-service-16e74e4353e9.herokuapp.com";
// export const SOCKET_URL =
//   "https://campaign-app-server-aa5e033e3a87.herokuapp.com";
// export const API_SERVICE_BACKEND =
//   "https://campaign-app-server-aa5e033e3a87.herokuapp.com/api/v1/main";
// ----------------------------------------------------------------------------------------------------
export const SALES_CHAT = `${selfURL}/chat`;
export const API_HIPPO_VIDEO =
  "https://b2b-hippo-video-email.azurewebsites.net/api/v1/main";
export const API_HIPPO_URL =
  "https://b2b-hippo-video-email.azurewebsites.net/api/v1/main";
export const TINYMCE_EDITOR_API = process.env.REACT_APP_TINYMCE_API;
export const PROFILE_PHOTO_URL =
  "https://b2brocketstorage.blob.core.windows.net/profile-pictures-vendor";
// Heroku, Netlify deployment
// export const SALES_CHAT = "https://react-sales-agent.vercel.app/chat";
// export const EMAIL_SERVER =
//   "https://campaign-email-service-200f5ab1ce43.herokuapp.com";
// export const SOCKET_URL =
//   "https://campaign-app-server-53f7eb36ce72.herokuapp.com";
// export const API_SERVICE_BACKEND =
//   "https://campaign-app-server-53f7eb36ce72.herokuapp.com/api/v1/main";
// Azure deployment
// export const SALES_CHAT =
//   "https://lively-smoke-0529ef710.3.azurestaticapps.net/chat";
// export const EMAIL_SERVER = "https://campaign-email-service.azurewebsites.net";
// export const SOCKET_URL = "https://campaign-app-server.azurewebsites.net";
// export const API_SERVICE_BACKEND =
//   "https://campaign-app-server.azurewebsites.net/api/v1/main";
// others
// export const SOCKET_URL = "https://https://api.b2brocket.ai";
// export const API_SERVICE_BACKEND = API_SERVICE_BACKEND;
export const cronofy = {
  redirect_uri: window.location.origin,
  client_id: process.env.REACT_APP_CRONOFY_CLIENT_ID,
  client_secret: process.env.REACT_APP_CRONOFY_CLIENT_SECRET,
  data_center: "us",
  sub: "acc_64a4f90c4359010594c8f1fc",
  scope: "read_write",
  meetPrefs: {
    delayInMS: 5 * 60 * 1000, // 5 mins
    durationInMins: 15,
    allowMeetsUptoXDaysInFuture: 14,
  },
};
export const APP_TIMEZONE =
  process.env.REACT_APP_TIMEZONE || "America/New_York";
export const googleWebAppConfig = {
  oauth_url: `${API_AUTH_SERVICE_BACKEND}/oauth/google`,
};
export const job_import_api_key = process.env.REACT_APP_JOB_IMPORT_API_KEY;
export const microsoftWebAppConfig = {
  oauth_url: `${API_AUTH_SERVICE_BACKEND}/oauth/microsoft`,
};
// export const salesforceOauthConfig = {
//   oauthUrl: "https://login.salesforce.com/services/oauth2/authorize",
//   clientId:process.env.REACT_APP_SALESFORCE_CLIENT_ID,
//   // redirectUrl: 'http://localhost:3000/dashboard/account?tab=integrations',
//   redirectUrl: "https://app.b2brocket.ai/dashboard/account?tab=integrations",
//   apiVersion: "v61.0",
//   instanceUrl: "https://energy-drive-8689.my.salesforce.com",
//   scopes: ["full", "refresh_token"].join(" "),
// };
export const salesforceOauthConfig = {
  oauthUrl: "https://login.salesforce.com/services/oauth2/authorize",
  clientId:process.env.REACT_APP_SALESFORCE_CLIENT_ID,
  // redirectUrl: "http://localhost:3000/dashboard/account?tab=integrations",
  redirectUrl: "https://app.b2brocket.ai/dashboard/account?tab=integrations",
  apiVersion: "v61.0",
  instanceUrl: "https://orgfarm-0fe8b4e86a-dev-ed.develop.my.salesforce.com",
  scopes: ["full", "refresh_token"].join(" "),
};
// pr review test